const rfidField = document.querySelector("#js--rfid_code");
if (rfidField !== undefined && rfidField !== null) {
  rfidField.addEventListener("change", () => {
    if (rfidField.value[0] === "0") {
      rfidField.value = rfidField.value.substring(1);
    }
  });
}
